var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageOffMini(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 30 30",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "icon-outline",
    d: "m2.1 7.6h22.2v12.8h-15.4l-3.1 3.1v-3.1h-3.7zm-1.8-1.8v16.4h3.7v5.6l5.6-5.6h16.5v-16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-white",
    d: "m2.1 20.3h3.7v3.1l3.1-3.1h15.5v-12.7h-22.3z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "icon-highlight"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.9 15.3h3.5v1.8h-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.8 15.3h3.5v1.8h-3.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageOffMini);
export default __webpack_public_path__ + "static/media/message_off_mini.09455422.svg";
export { ForwardRef as ReactComponent };